<template>
  <v-container
    fluid
  >
    <v-row align="stretch">
      <v-col
        cols="12"
        md="6"
      >
        <base-material-card
          class="px-5 py-3"
          color="bgTemperature"
          inline
          icon="mdi-coolant-temperature"
        >
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgTemperature pa-8">
              {{ $t("tanks-set.information") }}
              <span class="subtitle-1">— {{ temperatureInfo.idNavigation.description }}</span>
            </div>
          </template>
          <validation-observer
            v-slot="{ handleSubmit }"
          >
            <form @submit.prevent="handleSubmit(updateMinMax)">
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <h3 class="info--text">
                    {{ $t('temperature-set.registerAt') }}:
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <p class="font-weight-bold">
                    {{ temperatureInfo.registerAt | formatDate }}
                  </p>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <h3 class="info--text">
                    {{ $t('temperature-set.min') }}:
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required|between:-9999,@Max"
                    name="Min"
                  >
                    <v-text-field
                      v-model.number="temperatureInfo.min"
                      :error-messages="errors"
                      color="secondary"
                      label=""
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <h3 class="info--text">
                    {{ $t('temperature-set.max') }}:
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required|between:@Min,9999"
                    name="Max"
                  >
                    <v-text-field
                      v-model.number="temperatureInfo.max"
                      :error-messages="errors"
                      color="secondary"
                      label=""
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <h3 class="info--text">
                    {{ $t('temperature-set.type-temperature') }}:
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <p class="font-weight-bold">
                    {{ temperatureInfo.isFahrenheit ? '°F' : '°C' }}
                  </p>
                </v-col>
              </v-row>
              <div class="pa-3 text-center">
                <v-btn
                  color="warning"
                  default
                  @click="cancel"
                >
                  {{ $t('goToList') }}
                </v-btn>
                <v-btn
                  color="success"
                  default
                  type="submit"
                >
                  {{ $t("save") }}
                </v-btn>
              </div>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <temperature-state-view :target-device-id="targetDeviceId" />
      </v-col>
    </v-row>
    <base-material-snackbar
      v-model="showSuccessAlert"
      :dismissible="false"
      type="success"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['timeout']: 1000
      }"
    >
      <span class="text-uppercase">{{ $t('Success') }} </span>
    </base-material-snackbar>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>

    <alert-list
      :target-device-id="targetDeviceId"
      alert-type="Temp"
    />
  </v-container>
</template>

<script>
  import mqtt from 'mqtt'
  import filters from '@/common/filters'
  import TemperatureStateView from '@/views/dashboard/components/temperature/TemperatureStateView'
  import { repositoryFactory } from '@/api/repositoryFactory'
  import AlertList from '../components/alerts/AlertList'
  const temperaturesRespository = repositoryFactory.get('temperatures')

  export default {
    components: { TemperatureStateView, AlertList },
    mixins: [filters],
    data () {
      return {
        temperatureInfo: {
          idNavigation: { },
        },
        showErrorMessage: false,
        errorMessage: '',
        showSuccessAlert: false,
        loadingUpdateMinMax: false,
        connection: {
          host: 'mqtt.multisensores.com',
          port: 8084,
          endpoint: '/mqtt',
          clean: true, // Reserved session
          connectTimeout: 4000, // Time out
          reconnectPeriod: 4000, // Reconnection interval
          // Certification Information
          clientId: 'minmax_view_temp',
          username: 'minmax_view_temp_user',
          password: 'minmax_view_temp_pass',
        },
        client: {
          connected: false,
        },
      }
    },
    computed: {
      targetDeviceId () {
        return this.$route.params.id
      },
    },
    mounted () {
      this.createConnection()
      this.fetchData(this.targetDeviceId)
    },
    methods: {
      fetchData (targetDeviceId) {
        var self = this
        temperaturesRespository.get(targetDeviceId).then(response => {
          self.temperatureInfo = response.data.data
        }).catch(err => {
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
      updateMinMax () {
        var self = this
        var data = {
          data: this.temperatureInfo,
        }
        self.loadingUpdateMinMax = true
        temperaturesRespository.updateMinMax(data, this.temperatureInfo.id).then(response => {
          if (response.data.isValid) {
            self.showSuccessAlert = true
            self.$root.$emit('updateTemperatureStateView')
            self.client.publish('terrapez/alerts', 'update')
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loadingUpdateMinMax = false
        }).catch(err => {
          self.errorMessage = err
          self.showErrorMessage = true
          self.loadingUpdateMinMax = false
        })
      },
      cancel () {
        this.$router.push({ name: 'temperatures' })
      },
      createConnection () {
        // Connect string, and specify the connection method used through protocol
        // ws unencrypted WebSocket connection
        // wss encrypted WebSocket connection
        // mqtt unencrypted TCP connection
        // mqtts encrypted TCP connection
        // wxs WeChat mini app connection
        // alis Alipay mini app connection
        this.connection.clientId = 'minmax_view_temp_' + Math.round(Math.random() * (0 - 10000) * -1)

        const { host, port, endpoint, ...options } = this.connection
        const connectUrl = `wss://${host}:${port}${endpoint}`
        try {
          this.client = mqtt.connect(connectUrl, options)
        } catch (error) {
          console.log('mqtt.connect error', error)
        }
        this.client.on('connect', () => {
          console.log('Connection succeeded!')
        })
        this.client.on('error', error => {
          console.log('Connection failed', error)
        })
      },
    },
  }
</script>

<style>
.bgTemperature{
  background-color: #023A66 !important;
}
</style>
